import { ADMIN_METAS_FORM } from './index';
import { Action } from '../action';
import { AccessCodeServiceCustomFields, AccessCodeServiceCustomFieldsValue } from '@shared/core';

export class AdminMetasFormInitAction implements Action {
	readonly type = ADMIN_METAS_FORM.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasFormDestroyAction implements Action {
	readonly type = ADMIN_METAS_FORM.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasFormClickImportAction implements Action {
	readonly type = ADMIN_METAS_FORM.CLICK_IMPORT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasFormClickAddOrganizationAction implements Action {
	readonly type = ADMIN_METAS_FORM.CLICK_ADD_ORGANIZATION;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasFormClickAddGroupAction implements Action {
	readonly type = ADMIN_METAS_FORM.CLICK_ADD_GROUP;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasFormClickAddOptionAction implements Action {
	readonly type = ADMIN_METAS_FORM.CLICK_ADD_OPTION;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasFormClickEditOptionAction implements Action {
	readonly type = ADMIN_METAS_FORM.CLICK_EDIT_OPTION;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasFormClickDeleteOptionAction implements Action {
	readonly type = ADMIN_METAS_FORM.CLICK_DELETE_OPTION;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasFormReadFileAction implements Action {
	readonly type = ADMIN_METAS_FORM.READ_FILE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminMetasFormReadFileSuccessAction implements Action {
	readonly type = ADMIN_METAS_FORM.READ_FILE_SUCCESS;
	constructor(
		public payload: any[],
		public correlationId?: number
	) {}
}

export class AdminMetasFormReadFileErrorAction implements Action {
	readonly type = ADMIN_METAS_FORM.READ_FILE_ERROR;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminMetasFormAddOptionAction implements Action {
	readonly type = ADMIN_METAS_FORM.ADD_OPTION;
	constructor(
		public payload: AccessCodeServiceCustomFieldsValue,
		public correlationId?: number
	) {}
}

export class AdminMetasFormImportOptionsAction implements Action {
	readonly type = ADMIN_METAS_FORM.IMPORT_OPTIONS;
	constructor(
		public payload: AccessCodeServiceCustomFieldsValue[],
		public correlationId?: number
	) {}
}

export class AdminMetasFormUpdateOptionAction implements Action {
	readonly type = ADMIN_METAS_FORM.UPDATE_OPTION;
	constructor(
		public payload: AccessCodeServiceCustomFieldsValue,
		public correlationId?: number
	) {}
}

export class AdminMetasFormSelectOptionAction implements Action {
	readonly type = ADMIN_METAS_FORM.SELECT_OPTION;
	constructor(
		public payload: number,
		public correlationId?: number
	) {}
}

export class AdminMetasFormSelectOrganizationCodeAction implements Action {
	readonly type = ADMIN_METAS_FORM.SELECT_ORGANIZATION_CODE;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminMetasFormSelectGroupCodeAction implements Action {
	readonly type = ADMIN_METAS_FORM.SELECT_GROUP_CODE;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminMetasFormClickSubmitAction implements Action {
	readonly type = ADMIN_METAS_FORM.CLICK_SUBMIT;
	constructor(
		public payload: AccessCodeServiceCustomFields,
		public correlationId?: number
	) {}
}

export class AdminMetasFormUpdateFormAction implements Action {
	readonly type = ADMIN_METAS_FORM.UPDATE_FORM;
	constructor(
		public payload: AccessCodeServiceCustomFields,
		public correlationId?: number
	) {}
}

export class AdminMetasFormUpdateAction implements Action {
	readonly type = ADMIN_METAS_FORM.UPDATE;
	constructor(
		public payload: AccessCodeServiceCustomFields,
		public correlationId?: number
	) {}
}

export class AdminMetasFormUpdateSuccessAction implements Action {
	readonly type = ADMIN_METAS_FORM.UPDATE_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasFormUpdateFailureAction implements Action {
	readonly type = ADMIN_METAS_FORM.UPDATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminMetasFormAddAction implements Action {
	readonly type = ADMIN_METAS_FORM.ADD;
	constructor(
		public payload: AccessCodeServiceCustomFields,
		public correlationId?: number
	) {}
}

export class AdminMetasFormAddSuccessAction implements Action {
	readonly type = ADMIN_METAS_FORM.ADD_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminMetasFormAddFailureAction implements Action {
	readonly type = ADMIN_METAS_FORM.ADD_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
